export const AGENT_CATEGORY_VALUES = {
  documentAnalysis: 'document_analysis',
  bidTabulations: 'bid_tabulations',
} as const;

export type AgentCategory =
  (typeof AGENT_CATEGORY_VALUES)[keyof typeof AGENT_CATEGORY_VALUES];

export const AGENT_CATEGORY_LABELS: Record<AgentCategory, string> = {
  document_analysis: 'Document Analysis',
  bid_tabulations: 'Bid Tabulations',
};
